<template>
  <div class="page-container">
    <div>
      <img src="~@/assets/svgs/exception/404.svg" alt="" />
    </div>
    <div>
      <h1>抱歉，你访问的页面不存在</h1>
      <van-button type="primary" @click="goHome">回到首页</van-button>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
const router = useRouter();
function goHome() {
  router.push('/');
}
</script>

<style lang="less" scoped>
.root-div {
  display: flex;
  flex-direction: column;
  justify-content: center;

  &>div {
    text-align: center;

    h1 {
      color: gray;
      font-weight: 500;
    }
  }
}

.page-container {
  height: 100%;

  .text-center {
    h1 {
      color: #666;
      padding: 20px 0;
    }
  }

  img {
    width: 350px;
    margin: 0 auto;
  }
}
</style>
